/** Parse CSV text into a 2D string array. Handles quoted fields, commas, escaped quotes. */
export function parseCSV(text: string): string[][] {
  const rows: string[][] = [];
  let row: string[] = [];
  let field = "";
  let inQuotes = false;
  for (let i = 0; i < text.length; i++) {
    const c = text[i];
    if (inQuotes) {
      if (c === '"' && text[i + 1] === '"') { field += '"'; i++; }
      else if (c === '"') { inQuotes = false; }
      else { field += c; }
    } else {
      if (c === '"') inQuotes = true;
      else if (c === ",") { row.push(field); field = ""; }
      else if (c === "\n") { row.push(field); rows.push(row); row = []; field = ""; }
      else if (c === "\r") { /* ignore */ }
      else { field += c; }
    }
  }
  if (field !== "" || row.length) { row.push(field); rows.push(row); }
  return rows.filter((r) => r.some((cell) => cell.trim() !== ""));
}

/** Map a CSV grid to an array of objects using a header→field lookup. */
export function mapCSV<T extends Record<string, string | undefined>>(
  grid: string[][],
  fieldMap: Record<string, keyof T>,
  /** A field name that must be non-empty OR a predicate function. */
  required: keyof T | ((row: T) => boolean),
): { rows: T[]; unmapped: string[] } {
  const [rawHeaders = [], ...body] = grid;
  const headers = rawHeaders.map((h) => h.trim().toLowerCase());
  const unmapped: string[] = [];
  const idx: (keyof T | null)[] = headers.map((h) => {
    const f = fieldMap[h];
    if (!f) unmapped.push(h);
    return f ?? null;
  });
  const predicate =
    typeof required === "function"
      ? required
      : (r: T) => !!r[required as keyof T];
  const rows = body
    .map((r) => {
      const o: any = {};
      r.forEach((cell, i) => {
        const f = idx[i];
        if (f) o[f] = cell.trim();
      });
      return o as T;
    })
    .filter(predicate);
  return { rows, unmapped };
}
